import selectors from './index'
import { ENTITY_EMAIL_CAMPAIGNS } from '../../config/constants'

export const getAll = state => {
  console.log('emailCampaigns.ids:', state.emailCampaigns.ids)
  console.log('resources.emailCampaigns:', state.resources[ENTITY_EMAIL_CAMPAIGNS])

  const all = state.emailCampaigns.ids
    .map(id => {
      const entity = selectors.collections.getEntity(state, ENTITY_EMAIL_CAMPAIGNS, id)
      if (!entity) {
        console.warn('Missing entity for id', id)
      }
      return entity
    })
    .filter(Boolean)

  console.log('SELECTED campaigns:', all)
  return all
}




export const getById = (state, id) =>
  selectors.collections.getEntity(state, ENTITY_EMAIL_CAMPAIGNS, id)

export const getIds = state => state.emailCampaigns.ids
export const getCount = state => state.emailCampaigns.count
export const getIsFetching = state => state.emailCampaigns.isFetching
export const getPage = state => state.emailCampaigns.page

